import React, { FC, useEffect, useState } from "react";
import Modal from "react-modal";
import classNames from "classnames";

import { WaitlistCenterOpeningStatus } from "../../Blocks/Waitlist/WaitlistCenterOpeningStatus.csharp";
import { WaitlistViewModel } from "../../Blocks/Waitlist/WaitlistViewModel.csharp";
import { WaitlistWaitWhileStatus } from "../../../Integrations/WaitWhile/Model/WaitlistWaitWhileStatus.csharp";

import { BookingButton } from "../BookingButton/BookingButton";

import {
  updateCenterOpeningStatus,
  getFormattedTime,
  updateWaitlistStatus,
} from "./WaitListHelpers";
import { WaitWhileModal } from "./WaitWhileModal";
import { LoadingAnimation } from "../LoadingAnimation/LoadingAnimation";

export const Waitlist: FC<WaitlistViewModel> = (waitList) => {
  const [openingStatus, setOpeningStatus] =
    useState<WaitlistCenterOpeningStatus>(waitList.initialCenterOpeningStatus);
  const [waitlistStatus, setWaitlistStatus] =
    useState<WaitlistWaitWhileStatus>();
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  const waitBeforeStartUpdatingCenterStatus = 5000;

  useEffect(() => {
    Modal.setAppElement("body");
  }, []);

  useEffect(() => {
    setTimeout(
      () => updateCenterOpeningStatus(waitList.contentId, setOpeningStatus),
      waitBeforeStartUpdatingCenterStatus
    );
  }, []);

  useEffect(() => {
    updateWaitlistStatus(waitList.contentId, setWaitlistStatus);
  }, []);

  const shouldRenderPopupButton =
    openingStatus &&
    (!openingStatus.isCenterOpen ||
      (openingStatus.isCenterOpen && !openingStatus.isWaitlistOpen));

  return (
    <div className="card theme-inherit-light h-100">
      <div className="card-body d-flex flex-column">
        <h3>{waitList.name}</h3>
        {!openingStatus ? (
          <LoadingAnimation
            text="Henter"
            className="loading-animation-container__waitlist"
          />
        ) : (
          <>
            <p className="fs-6 mb-3">
              <span
                className={classNames("fw-bold", {
                  "fs-5": openingStatus.isCenterOpen,
                })}
              >
                {openingStatus.openingTimeCurrentStatus}
              </span>
              <span>
                {" | "}
                {openingStatus.openingTimeNextStatus}
              </span>
            </p>
            {!openingStatus.isCenterOpen && (
              <p className="fw-bold">{openingStatus.centerClosedText}</p>
            )}
            {openingStatus.isCenterOpen && (
              <>
                {!waitlistStatus ? (
                  <LoadingAnimation
                    text="Henter"
                    className="loading-animation-container__waitlist"
                  />
                ) : (
                  <>
                    {waitlistStatus.waitingCountMessage && (
                      <p>
                        <span className="fw-bold">
                          {waitlistStatus.waitingCountMessage}
                        </span>
                        <span> ventende</span>
                      </p>
                    )}
                    <p
                      dangerouslySetInnerHTML={{
                        __html: getFormattedTime(waitlistStatus) ?? "",
                      }}
                    />
                  </>
                )}
              </>
            )}
          </>
        )}
        <div className="mt-auto mb-1">
          {shouldRenderPopupButton && (
            <button
              className="btn btn-primary w-100"
              onClick={() => setIsModalOpen(true)}
            >
              Sett deg i kø
            </button>
          )}
          {openingStatus &&
            openingStatus.isCenterOpen &&
            openingStatus.isWaitlistOpen && (
              <BookingButton
                bookingButton={{
                  ...waitList.dropInButton,
                  label: "Sett deg i kø",
                }}
                cssClass="btn btn-primary w-100"
                waitlist={waitList}
                awaitTime={getFormattedTime(waitlistStatus!)}
              />
            )}
        </div>
        {waitList.bookingButton && (
          <BookingButton
            bookingButton={{
              ...waitList.bookingButton,
              label: !!waitList.bookingTargetLabel
                ? waitList.bookingTargetLabel
                : "Bestille time i stedet?",
              description: waitList.bookingTargetDescription,
            }}
            cssClass="btn btn-link w-100 waitlist-booking-button"
            descriptionCssClass="fw-normal d-inline-block fs-6"
          />
        )}
        {!waitList.bookingButton && (
          <span
            className="btn btn-link text-decoration-none waitlist-booking-button"
            aria-hidden="true"
          >
            &nbsp;
          </span>
        )}
      </div>
      {openingStatus && (
        <WaitWhileModal
          Modal={Modal}
          isOpen={isModalOpen}
          buttonCloseFunction={setIsModalOpen}
          {...openingStatus}
        />
      )}
    </div>
  );
};
